/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWashDryShade = createReactComponent("wash-dry-shade", "IconWashDryShade", [
  [
    "path",
    {
      d: "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M3 11l8 -8", key: "svg-1" }],
  ["path", { d: "M3 17l14 -14", key: "svg-2" }]
]);

export { IconWashDryShade as default };
//# sourceMappingURL=IconWashDryShade.js.map
